import { IoIosInformationCircleOutline } from 'react-icons/io';
import { IoChevronUp, IoChevronDown } from 'react-icons/io5';

import { CustomNodeHeaderProps } from 'types';
import { NodeButtonView, NodeExpandButton, NodeHeader, NodeInOutTag, NodeNameView } from '../../ui';

const LayerNodeHeader = ({ data, onExpandClick }: CustomNodeHeaderProps) => {
  return (
    <NodeHeader>
      <NodeNameView>
        {data.target && <NodeInOutTag>IN</NodeInOutTag>}
        {data.source && <NodeInOutTag>OUT</NodeInOutTag>}
        <span>{data.name}</span>
      </NodeNameView>
      <NodeButtonView>
        <a href={data.link} target="_blank" rel="noopener noreferrer">
          <IoIosInformationCircleOutline />
        </a>
        <NodeExpandButton onClick={onExpandClick}>{data.expand ? <IoChevronUp /> : <IoChevronDown />}</NodeExpandButton>
      </NodeButtonView>
    </NodeHeader>
  );
};

export default LayerNodeHeader;
